import { boolean } from "../types/boolean";

export default function(a, b) {
  a = boolean(a);
  b = boolean(b);
  return a && b;
}
